export default "__VITE_ASSET__C0yhzl3m__"